import React, { createElement, useCallback } from "react"
import { create } from "zustand"

import {
    IActionResult,
    IGameBlueprint,
    IGameCharacter,
    IGameDialog,
    IGameEquipWithAction,
    IGameGift,
    IGameItem,
    IGameResult,
    IKaltsAction,
    IPerformance,
} from "../pages/Game/type"

interface I18nObjects {
    // battle.ts
    WIN_PERFORMANCE: IPerformance[]
    FAIL_PERFORMANCE: IPerformance[]
    SPECIAL_PERFORMANCE: IPerformance[]
    KILL_PERFORMANCE: IPerformance[]

    KALTS_ACTION_DICT: Record<string, IKaltsAction>
    GAME_EQUIP_DICT: Record<string, IGameEquipWithAction>

    getNymphSummaryText: (result: IActionResult) => string
    getKaltsSummaryText: (result: IActionResult) => string
    getKaltsCheckBuffText: (damage: number) => string
    rollKaltsAction: (ultra: boolean, noHeal: boolean) => IKaltsAction

    // character.ts
    CHARACTER_DICT: Record<string, IGameCharacter>

    // craft.ts
    GAME_BLUEPRINT_DICT: Record<string, IGameBlueprint>

    // dialog.ts
    DIALOG_ARR: IGameDialog[]
    DIALOG_DICT: Record<string, IGameDialog>

    DIALOG_BOSS: string[]
    DIALOG_TRAIL: string[]

    // gift.ts
    GAME_GIFT_DICT: Record<string, IGameGift>

    // item.ts
    GAME_ITEM_DICT: Record<string, IGameItem>

    // result.ts
    GAME_RESULT_DICT: Record<string, IGameResult>
}

export interface GameI18nStore {
    LoginView: React.FC<{ className?: string; style?: React.CSSProperties }>

    objects?: I18nObjects
}

export const useGameI18nStore = create<GameI18nStore>(() => ({
    LoginView: () => <></>,
}))

export const useTranslationObjects = () => {
    const objects = useGameI18nStore((state) => state.objects)
    const t = useCallback(
        (key: keyof I18nObjects) => {
            return objects?.[key]
        },
        [objects]
    )
    return { t, dict: objects! as I18nObjects }
}
